import styled from 'astroturf/react';

const MilestoneProgressBarWrapper = styled('div')`
    display: flex;
    margin: auto;
    width: 90%;
    flex-direction: column;
    justify-content: center;   
    margin-bottom: 40px;
`;

const MilestoneProgressBarPart = styled('div')`    
    display: flex;
    min-width: 100%;
    height: 8px;
    background: var(--ph-gray-250);
    &:after{
        content: "|";
        margin-top: -10px;
        width: 2px;
        font-size: 19px;
        position: relative;
        margin-left: -2px;
    }
    &:before{
        content: '|';
        width: 2px;
        font-size: 19px;
        margin-top: -10px;
        margin-left: -3px;
    }
`;

const MilestoneBar  = styled('div')`
    width: 100%;
`;

const MilestoneCompleted = styled('div')`
    height: 8px;
    float: left;
    background: var(--dark-blue);
    &[class*='withOutDelay']:after{
        content: '';
        display: block;
        background: var(--cyan-green);
        height: 10px;
        text-align: center;
        transform: rotate(45deg);
        width: 10px;
        border: 1px solid var(--dark-blue);
        margin-top: -1px;    
        position: relative;
        left: calc(100% - 5px);
        z-index: 1;
    }
    &[class*='withDelay']:after{
        content: "|";
        margin-top: -10px;
        width: 2px;
        font-size: 19px;
        display: block;
        position: relative;
        left: calc(100% - 3px);
    }
`;

const MilestoneDelay = styled('div')`
    height: 8px;
    float: left;
    background: var(--ph-red-500);
    &[class*='withDelay']:after{
        content: '';
        display: block;
        background: var(--cyan-green);
        height: 10px;
        text-align: center;
        transform: rotate(45deg);
        width: 10px;
        border: 1px solid var(--dark-blue);
        margin-top: -1px;    
        position: relative;
        left: calc(100% - 5px);
        z-index: 1;
    }
`;

const MilestoneLegend = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    min-width: 100%;
    color: var(--dark-blue);
    display: flex;
    flex-direction: row;
`;

const Label = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-semibold);
    &:after{
        content: " ";
        width: 2px;
        display: inline-block;
    }
`;

const DateLabel = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-regular);
`;

const StartDateWrapper = styled('div')`
    display: flex;
    flex-direction: row;

`;

const TargetCompletionDateWrapper = styled('div')`
    display: flex;
    flex-direction: row;

`;

const DelayDaysWrapper = styled('div')`
    color: var(--ph-red-500);
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const DaysLeftWrapper = styled('div')`
    font-size: 11px;
    font-family: var(--ph-font-family-source-sans-pro-regular);
    display: flex;
    flex-direction: row;
    position: absolute;
    text-align: right;
    justify-content: flex-end;
    margin-top: 35px;
    width: calc(90% - 108px);
`;

const CompletedDateWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    position: absolute;
    width: calc(90% - 108px);
    justify-content: flex-end;
    margin-top: 35px;
`;

export default {
    MilestoneProgressBarWrapper,
    MilestoneProgressBarPart,
    MilestoneBar ,
    MilestoneCompleted,
    MilestoneDelay,
    MilestoneLegend,
    Label,
    DateLabel,
    StartDateWrapper,
    TargetCompletionDateWrapper,
    DelayDaysWrapper,
    DaysLeftWrapper,
    CompletedDateWrapper
}
